<template>
  <div class="home">
    <h1>MAIN SITE</h1>
  </div>
</template>

<script>

export default {
  name: 'HomeView'
}
</script>
